import { render, staticRenderFns } from "./form-template-2.vue?vue&type=template&id=90f7cc4a&scoped=true"
import script from "./form-template-2.vue?vue&type=script&lang=js"
export * from "./form-template-2.vue?vue&type=script&lang=js"
import style0 from "./form-template-2.vue?vue&type=style&index=0&id=90f7cc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f7cc4a",
  null
  
)

export default component.exports